import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
    GridColumn,
    MxCustomizer,
    MxGridCustomizerEvent,
    MxGridButtonsConfig,
    MxInformationTooltipConfig
} from 'mx-core';
import { PrlTranslateService } from '../../../../shared/services/prl-translate.service';

@Component({
    selector: 'prl-profiles',
    templateUrl: './prl-profiles.component.html',
    standalone: false,
    styleUrls: ['./prl-profiles.component.scss']
})
export class PrlProfilesComponent implements OnInit, MxCustomizer<MxGridCustomizerEvent> {

    private gridColumns: GridColumn[] = [];
    private buttonsConfig: MxGridButtonsConfig;

    protected profilesTooltip: MxInformationTooltipConfig = {
        links: [],
        header: 'Help',
        content: 'label.profiles.all.profiles.help'
    };

    constructor(
        private router: Router,
        protected translateService: PrlTranslateService
    ) {}

    ngOnInit(): void {
        this.gridColumns = [
            new GridColumn({
                field: 'id',
                label: 'ID',
                sortable: true,
                hidden: true
            }),
            new GridColumn({
                field: 'name',
                label: () => this.translateService.getTranslatedLabel('label.profiles.name'),
                sortable: true,
                columnWidth: 150,
                idProp: 'id'
            }),
            new GridColumn({
                field: 'description',
                label: () => this.translateService.getTranslatedLabel('label.description'),
                sortable: true,
                columnWidth: 200
            }),
            new GridColumn({
                field: 'url',
                label: () => this.translateService.getTranslatedLabel('label.profiles.url'),
                sortable: true,
                columnWidth: 200
            }),
            new GridColumn({
                field: 'campaignName',
                label: () => this.translateService.getTranslatedLabel('label.profiles.campaign'),
                sortable: true,
                columnWidth: 150,
            }),
            new GridColumn({
                field: 'createdOn',
                label: () => this.translateService.getTranslatedLabel('label.date.created'),
                sortable: true,
                columnWidth: 150,
                type: 'date'
            })
        ];

        this.buttonsConfig = MxGridButtonsConfig
            .hideDefault()
            .setMultiple(new MxGridButtonsConfig([
                ['addButton', {
                    label: () => this.translateService.getTranslatedLabel('label.profiles.create.new'),
                    icon: 'add_circle_outline',
                    color: 'primary',
                    className: 'mxs-button--secondary',
                    clickHandler: () => this.onCreateProfileClick()
                }]
            ]));
    }

    onCustomize(event: MxGridCustomizerEvent): void {
        event.customizeLoadRowsOnStart(true)
            .customizeRestUrl('/profiles')
            .customizeColumns(this.gridColumns)
            .customizeActions(this.buttonsConfig)
            .customizeProps({
                selectionMode: 'single',
                showColumns: false
            })
            .customizeItemDetailsLink('/profiles');
    }

    onCreateProfileClick(): void {
        this.router.navigate(['/profiles/create']);
    }

}
